module.exports = __webpack_public_path__ + "img/grid-horizontal.69c68b6f.svg";